<template>
  <modal-window :loading="loading" v-on:close="$emit('closeProductEditor')">
    <template slot="header">
      <p class="modal-card-title">{{ header }}</p>
      <button class="delete" v-on:click="$emit('closeProductEditor')" aria-label="close"></button>
    </template>
    <template slot="body">

      <div class="field">
        <b-tooltip label="Name of the group" position="is-right">
          <label class="label">Name</label>
        </b-tooltip>
        <b-field v-bind:type="{'is-danger':  newGroupName.length < 2 && saveClicked}"
                 v-bind:message="{'You should specify a group name!' : newGroupName.length < 2 && saveClicked }">
          <b-input v-model.trim="newGroupName" maxlength="100" placeholder="FastReport Super Deluxe 3000"></b-input>
        </b-field>
      </div>

      <div>
        <label class="typo__label">Products</label>
        <multiselect v-model="products" :options="allProducts" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Pick some" label="name" track-by="name" :preselect-first="true">
          <template slot="selection" slot-scope="{ values, search, isOpen }">
            <span class="multiselect__single" v-if="products.length" v-show="!isOpen">{{ products.length }} products selected</span>
          </template>
        </multiselect>
      </div>
      <div>
        <pre class="has-background-white">









        </pre>
      </div>

      <!-- errors -->
      <br>
      <div class="has-text-left has-text-danger" v-if="errors.length">
        <b class="label is-danger">Please fix this error:</b>
        <ul>
          <li class="is-danger" v-for="(error,index) in errors" :key="index">{{ error }}</li>
        </ul>
      </div>
      <!-- end errors -->
    </template>
    <template slot="footer">
      <button class="button is-success" v-on:click="submit()">Save</button>
      <button class="button" v-on:click="$emit('closeProductEditor')">Cancel</button>
    </template>
  </modal-window>
</template>

<script>
  import Multiselect from 'vue-multiselect'
  import ModalWindow from "./ModalWindow";
  //import this.HTTP from "./Http";

  export default {
    name: "products-group-editor",
    components: { ModalWindow, Multiselect },
    props: {
      groupId: Number,
      header: String
    },
    data() {
      return {
        baseGroupId: 0,
        newGroupName: "",

        saveClicked: false,
        recordProcessing: false, //should prevent record duplicate creating
        errors: [],

        products: [],
        allProducts: [],
        loading: false
      };
    },
    methods: {
      createProductsGroup() {
        this.HTTP.post(`productGroups`, {
          name: this.newGroupName,
          productIds: this.products.map((x) => x.id)
        })
          .then(response => {
            this.recordProcessing = false;
            this.$emit("closeProductEditor");
          })
          .catch(e => {
            this.recordProcessing = false;
            this.errors = e.response.data.description;
          });
      },
      editProduct(groupId) {
        this.HTTP.put(`productGroups/` + groupId, {
          id: groupId,
          name: this.newGroupName,
          productIds: this.products.map((x) => x.id)
        })
          .then(response => {
            this.recordProcessing = false;
            this.$emit("closeProductEditor");
          })
          .catch(e => {
            this.recordProcessing = false;
            this.errors = e.response.data.description;
          });
      },

      getGroup(id) {
        this.loading = true;
        this.HTTP.get("productGroups/" + id)
          .then(response => {
            this.newGroupName = response.data.name;
            if (
              response.data.products != null &&
              response.data.products.length > 0
            ) {
              this.products = [];
              response.data.products.forEach(element => {
                this.products.push({ id: element.id, name: element.name });
              });
            }
            this.loading = false;
          })
          .catch(e => {
            this.loading = false;
            console.log(e);
          });
      },
      submit() {
        console.log("recordProcessing - " + this.recordProcessing);
        if (!this.recordProcessing) {
          this.saveClicked = true;
          if (this.newGroupName.length >= 2 && this.products.length > 0) {
            this.recordProcessing = true;
            if (this.groupId <= 0) this.createProductsGroup();
            else this.editProduct(this.groupId);
          }
        }
      },
      getProducts() {
        this.HTTP.get("Products/1/9999")
          .then(response => {
            this.allProducts = response.data.entities.map((x) => { return { id: x.id, name: x.name } });
          })
          .catch(e => {
            console.log(e);
          });
      },
      isInteger(num) {
        return (num ^ 0) === num;
      },
    },

    created() {
      document.addEventListener("keydown", this.keyDownListener);
      this.getProducts();
      if (this.groupId > 0) {
        this.getGroup(this.groupId);
      }
    },
    destroyed: function () {
      document.removeEventListener("keydown", this.keyDownListener);
    }
  };
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/components/ProductsGroupEditor.vue